/* eslint-disable react-refresh/only-export-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import moment from "moment";
import { styled } from "styled-components";
import { Colors } from "../../../styles/Colors";
import { AvailabilityRequest } from "./queries";
import { FareCode, JourneyType } from "./types";
export const readyCheck = (portDeparture, portArrival, dateDeparture, dateReturn, isJourneyAvailable, isLoading, ticketType) => {
    if (isLoading)
        return false;
    if (isJourneyAvailable !== null && isJourneyAvailable === false)
        return false;
    if (ticketType !== JourneyType.Return)
        return portDeparture && portArrival && dateDeparture;
    return portDeparture && portArrival && dateDeparture && dateReturn;
};
export const transformPortsOriginOptions = (ports) => ports && ports.length > 0
    ? ports.map((port) => ({
        id: port.originPort.portCode,
        title: port.originPort.portName,
        key: `port-${port.originPort.portCode}`,
    }))
    : [];
export const transformPortsDestinationOptions = (ports) => ports && ports.length > 0
    ? ports.map((port) => ({
        id: port.portCode,
        title: port.portName,
        key: `port-destination-${port.portCode}`,
    }))
    : [];
export const handlePlaceholder = (value, t) => {
    if (value === 1)
        return `${value} ${t("booking.passengers.adult.singular")}, ...`;
    return `${value} ${t("booking.passengers.adult.plural")}, ...`;
};
const CheckAvailability = ({ setIsJourneyAvailable, setCheckAvailability, setIsLoading, sendData, }) => {
    const { loading, error, data } = useQuery(AvailabilityRequest, {
        variables: {
            requestParams: sendData,
        },
        fetchPolicy: "no-cache",
    });
    useEffect(() => {
        setIsLoading(loading);
    }, [loading, setIsLoading]);
    useEffect(() => {
        if (data) {
            setIsJourneyAvailable(data.availability.isJourneyAvailable);
            setCheckAvailability(false);
        }
    }, [data, setCheckAvailability, setIsJourneyAvailable]);
    if (error)
        setCheckAvailability(false);
    return null;
};
export default CheckAvailability;
export function currency(lang) {
    const langauge = lang;
    let curr = "NOK";
    switch (langauge) {
        case "en":
        case "de":
        case "nl":
            curr = "EUR";
            break;
        case "da":
            curr = "DKK";
            break;
        default:
            curr = "NOK";
    }
    return curr;
}
export const createSendData = (ticketType, lang, car, portArrival, dateDeparture, portDeparture, dateReturn, openVoucher, voucherCode, hasPromotionRules, hasProductRules) => {
    const sendData = {
        journeyType: ticketType.toUpperCase(),
        currency: currency(lang),
        language: lang,
        promotionCode: openVoucher && voucherCode && hasPromotionRules ? voucherCode : undefined,
        ticketCode: openVoucher && voucherCode && hasProductRules ? voucherCode : undefined,
        hasVehicles: !!car,
        hasPets: false,
        outbound: {
            destinationPort: portArrival.toUpperCase(),
            departureDate: moment(dateDeparture).format("YYYY-MM-DD"),
            originPort: portDeparture.toUpperCase(),
        },
    };
    if (ticketType === JourneyType.Return || ticketType === JourneyType.Package)
        sendData.inbound = {
            destinationPort: portDeparture.toUpperCase(),
            departureDate: moment(dateReturn).format("YYYY-MM-DD"),
            originPort: portArrival.toUpperCase(),
        };
    return sendData;
};
// Cart requires departure and arrival port (GRAPHQL uses originPort and destinationPort)
export const createCartData = (ticketType, lang, car, portArrival, dateDeparture, portDeparture, dateReturn, voucherCode, openVoucher, passengers, hasPromotionRules, hasProductRules) => {
    const sendData = {
        journeyType: ticketType.toUpperCase(),
        currency: currency(lang),
        language: lang,
        hasVehicle: !!car,
        hasPets: false,
        promotionCode: voucherCode && openVoucher && hasPromotionRules ? voucherCode : undefined,
        passengers,
        outbound: {
            arrivalPort: portArrival.toUpperCase(),
            departureDate: moment(dateDeparture).format("YYYY-MM-DD"),
            departurePort: portDeparture.toUpperCase(),
            ticket: voucherCode && openVoucher
                ? {
                    ticketCode: voucherCode && openVoucher && hasProductRules
                        ? voucherCode
                        : "",
                }
                : undefined,
        },
    };
    if (ticketType === JourneyType.Return || ticketType === JourneyType.Package)
        sendData.inbound = {
            arrivalPort: portDeparture.toUpperCase(),
            departureDate: moment(dateReturn).format("YYYY-MM-DD"),
            departurePort: portArrival.toUpperCase(),
            ticket: voucherCode && openVoucher
                ? {
                    ticketCode: voucherCode && openVoucher && hasProductRules
                        ? voucherCode
                        : "",
                }
                : undefined,
        };
    return sendData;
};
export const createPassengers = (adults, youth, todlers, infants) => {
    const passengers = [
        {
            code: FareCode.Adult,
            quantity: adults,
        },
        {
            code: FareCode.Child,
            quantity: youth,
        },
        {
            code: FareCode.Infant,
            quantity: todlers,
        },
        {
            code: FareCode.Baby,
            quantity: infants,
        },
    ];
    return passengers;
};
export const Wrapper = styled.div `
  min-height: 480px;
  padding: 40px 32px;
  gap: 24px;
  box-shadow: 0px 0px 15px rgba(34, 34, 34, 0.2);

  @media only screen and (max-width: 767px) {
    box-shadow: none;
    padding: 0;
    border-radius: 0;
  }

  border-radius: 10px;
  min-height: 315px;
  /* Normalize */
  main {
    display: block;
  }
  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }
  /* hr{box-sizing:content-box;height:0;overflow:visible;} */
  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  a {
    background-color: transparent;
  }
  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    text-decoration: underline dotted;
  }
  b,
  strong {
    font-weight: 500;
  }
  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  img {
    border-style: none;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
  }
  button,
  input {
    overflow: visible;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  [type=\"button\"],
  [type=\"reset\"],
  [type=\"submit\"] {
    -webkit-appearance: button;
  }
  button::-moz-focus-inner,
  [type=\"button\"]::-moz-focus-inner,
  [type=\"reset\"]::-moz-focus-inner,
  [type=\"submit\"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }
  button:-moz-focusring,
  [type=\"button\"]:-moz-focusring,
  [type=\"reset\"]:-moz-focusring,
  [type=\"submit\"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }
  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }
  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }
  progress {
    vertical-align: baseline;
  }
  textarea {
    overflow: auto;
  }
  [type=\"checkbox\"],
  [type=\"radio\"] {
    box-sizing: border-box;
    padding: 0;
  }
  [type=\"number\"]::-webkit-inner-spin-button,
  [type=\"number\"]::-webkit-outer-spin-button {
    height: auto;
  }
  [type=\"search\"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  [type=\"search\"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  details {
    display: block;
  }
  summary {
    display: list-item;
  }
  template {
    display: none;
  }
  [hidden] {
    display: none;
  }

  /* line-height: 1.4375; */
  /* font-family: 'Colfax', Arial, Helvetica, sans-serif; */
  /* color: #000000; */
  /* -webkit-overflow-scrolling: touch; */
  /* line-height: 1.4375; */
  font-size: 14px;

  div > * {
    font-size: 16px !important;
    font-weight: 400 !important;
  }

  div > .modal-anchor h3 {
    font-size: 22px !important;
    line-height: 32px !important;
    margin-bottom: 1em;
  }

  div > .modal-anchor label {
    font-weight: 500 !important;
    margin-bottom: 1em;
  }

  div > .modal-anchor label > div {
    font-size: 16px !important;
  }

  div > .modal-anchor div > div > div > div > label > div {
    padding-top: 5px;
  }

  div > .modal-anchor label input[type="radio"] {
    font-size: 10px !important;
  }

  div > .modal-anchor hr {
    margin: 1em 0 1.5em;
  }

  div > h3 {
    font-weight: inherit !important;
  }

  #option-links > div > div > fieldset > label > input {
    width: 20px;
    height: 20px;
  }

  #option-links > div > div > fieldset > a,
  #option-links > div > div > fieldset > label > span,
  div > label > span {
    font-weight: 400 !important;
    font-size: 16px !important;
  }

  label > div > div > div > svg {
    margin-top: -14px;
  }

  input {
    min-height: 1em;
  }

  input[type="text"] {
    min-height: 40px;
  }

  fieldset {
    margin-bottom: auto;
  }

  @media only screen and (min-width: 768px) {
    [data-focus-lock-disabled="false"] > div > div {
      min-width: 200px;
    }
  }

  @media only screen and (max-width: 767px) {
    div > .modal-anchor > div > div > div > div {
      flex-direction: row;
    }
  }

  .btn-standard-text {
    font-size: 1.5em;
  }

  .DayPicker-Day {
    line-height: 40px !important;
  }

  .DayPicker-wrapper > div > button {
    width: 20px;
    margin-top: 20px;
  }

  #port-selector div > label > span {
    font-size: 14px !important;
    font-weight: 500 !important;
  }

  button.btn-order span.btn-standard-text {
    font-size: 18px !important;
    line-height: 38px !important;
  }
  button.btn-order {
    height: 56px !important;
    padding: 0 32px !important;
  }

  a.black-link {
    color: #000000 !important;
    text-decoration: underline !important;
    text-decoration-color: #fcba30 !important;
    padding: 0 !important;
  }

  div#option-links {
    margin-bottom: 16px;
  }

  div#option-links * {
    /* border: 1px solid red; */
  }

  div#option-links label {
    align-items: center !important;
    margin-bottom: 0 !important;
  }

  form {
    margin-bottom: 0 !important;
  }

  .option-header {
    h3 {
      font-weight: normal;
    }
    .selected {
      font-weight: 500 !important;
    }
  }
`;
export const ModalAnchor = styled.div `
  width: 100%;
  svg {
    width: 16px;
    height: 16px;
  }
`;
export const TweakedModal = styled.div `
  input {
    max-width: 60px;
  }
  @media only screen and (min-width: 768px) {
    background: #ffffff;
    right: ${(props) => (props.isReturn ? "0" : "none")};
    position: fixed;
    z-index: 999999;
    margin: auto;
    margin-top: -1rem;
    margin-right: 4rem;
    border-radius: 4px;
    outline: none;
    box-shadow: 0 0.125rem 0.2rem 0 rgba(0, 0, 0, 0.25);
    max-width: 1120px;
    padding: 20px;
    color: #222222;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    animation: 0 300ms linear;
    animation-iteration-count: 1;
  }

  button {
    height: auto;
  }

  > button {
    position: fixed;
    right: 50px;
    background: none;

    :hover {
      border: none;
    }
  }

  > button > span {
    font-weight: 500 !important;
  }

  input {
    margin-right: 10px !important;
  }

  span {
    font-size: 20px !important;
  }

  @media only screen and (max-width: 767px) {
    box-shadow: 0px 0px 15px rgba(34, 34, 34, 0.2);
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    padding: 32px 24px;
    margin-top: -1.5rem;
    margin-bottom: 1em;
    > div > div {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 0.6rem;
    }

    button {
      padding: 0;
    }
  }
`;
export const StyledDisabledDate = styled.div `
  width: 100%;
  .rdp-table {
    max-width: 100%;
  }
  .rdp-caption_label {
    font-weight: 500 !important;
  }
  .rdp-day {
    font-weight: 500;

    :hover {
      color: ${Colors.PROFILE_YELLOW};
    }
  }

  .rdp-nav_button_next:hover {
    color: ${Colors.PROFILE_YELLOW};
  }

  .rdp-nav_button_previous:hover {
    color: ${Colors.PROFILE_YELLOW};
  }

  .rdp-day_disabled {
    border-radius: 80%;
    color: #dbdbdb;
  }

  .rdp-day_disabled {
    background: #f6f5f3;
    border-radius: 0;
    pointer-events: none;

    > span {
      color: #00000080;
    }
  }

  .rdp-day_disabled:hover {
    background: #e0e0e0 !important;
    cursor: not-allowed;
  }
`;
//# sourceMappingURL=helper.js.map